import DispensaryFulfillmentInfo from "./DispensaryFulfillmentInfo";

export default DispensaryFulfillmentInfo;
